/**
 * Auto-generated TypeScript bindings for Tauri commands
 * Generated by tauri-typegen v0.5.0
 * Generated at: 2026-09-04T05:23:35.728166941+00:00
 * Generator: none
 *
 * Do not edit manually - regenerate using: cargo tauri-typegen generate
 */

import { invoke, Channel } from '@tauri-apps/api/core';
import * as types from './types';

export async function abortLoopbackFetch(params: types.AbortLoopbackFetchParams): Promise<void> {
  return invoke('abort_loopback_fetch', params);
}

export async function abortNativeUpload(params: types.AbortNativeUploadParams): Promise<void> {
  return invoke('abort_native_upload', params);
}

export async function activateCallAudioSession(): Promise<void> {
  return invoke('activate_call_audio_session');
}

export async function buildDiagnosticsArchive(params: types.BuildDiagnosticsArchiveParams): Promise<number[]> {
  return invoke('build_diagnostics_archive', params);
}

export async function clearMediaSession(): Promise<void> {
  return invoke('clear_media_session');
}

export async function deactivateCallAudioSession(): Promise<void> {
  return invoke('deactivate_call_audio_session');
}

export async function engineClose(params: types.EngineCloseParams): Promise<boolean> {
  return invoke('engine_close', params);
}

export async function engineDecryptPush(params: types.EngineDecryptPushParams): Promise<types.DecryptedPush> {
  return invoke('engine_decrypt_push', params);
}

export async function engineInvoke(params: types.EngineInvokeParams): Promise<string> {
  return invoke('engine_invoke', params);
}

export async function engineOpen(params: types.EngineOpenParams): Promise<types.EngineInfo> {
  return invoke('engine_open', params);
}

export async function engineWipe(params: types.EngineWipeParams): Promise<void> {
  return invoke('engine_wipe', params);
}

export async function ensureLoopbackMedia(): Promise<void> {
  return invoke('ensure_loopback_media');
}

export async function exportDiagnostics(params: types.ExportDiagnosticsParams): Promise<string | null> {
  return invoke('export_diagnostics', params);
}

export async function getDesktopRuntimeState(): Promise<types.DesktopRuntimeState> {
  return invoke('get_desktop_runtime_state');
}

export async function hapticFeedback(params: types.HapticFeedbackParams): Promise<void> {
  return invoke('haptic_feedback', params);
}

export async function hideSnapOverlay(): Promise<void> {
  return invoke('hide_snap_overlay');
}

export async function isWindowTrackingActive(): Promise<boolean> {
  return invoke('is_window_tracking_active');
}

export async function loopbackFetch(params: types.LoopbackFetchParams): Promise<types.LoopbackFetchResponse> {
  return invoke('loopback_fetch', params);
}

export async function nativeUpload(params: types.NativeUploadParams): Promise<types.NativeUploadResponse> {
  return invoke('native_upload', params);
}

export async function playNotificationSound(params: types.PlayNotificationSoundParams): Promise<void> {
  return invoke('play_notification_sound', params);
}

export async function prepareLoopbackMedia(params: types.PrepareLoopbackMediaParams): Promise<string> {
  return invoke('prepare_loopback_media', params);
}

export async function saveDownload(params: types.SaveDownloadParams): Promise<boolean> {
  return invoke('save_download', params);
}

export async function saveMediaDownload(params: types.SaveMediaDownloadParams): Promise<boolean> {
  return invoke('save_media_download', params);
}

export async function saveMediaToPhotos(params: types.SaveMediaToPhotosParams): Promise<void> {
  return invoke('save_media_to_photos', params);
}

export async function setImmersiveMode(params: types.SetImmersiveModeParams): Promise<void> {
  return invoke('set_immersive_mode', params);
}

export async function setMediaEncryption(params: types.SetMediaEncryptionParams): Promise<void> {
  return invoke('set_media_encryption', params);
}

export async function setMediaSession(params: types.SetMediaSessionParams): Promise<void> {
  return invoke('set_media_session', params);
}

export async function setNativeSentryEnabled(params: types.SetNativeSentryEnabledParams): Promise<void> {
  return invoke('set_native_sentry_enabled', params);
}

export async function setNavigationBarColor(params: types.SetNavigationBarColorParams): Promise<void> {
  return invoke('set_navigation_bar_color', params);
}

export async function setStatusBarColor(params: types.SetStatusBarColorParams): Promise<void> {
  return invoke('set_status_bar_color', params);
}

export async function setToggleWindowShortcut(params: types.SetToggleWindowShortcutParams): Promise<types.DesktopRuntimeState> {
  return invoke('set_toggle_window_shortcut', params);
}

export async function setTrayBadge(params: types.SetTrayBadgeParams): Promise<void> {
  return invoke('set_tray_badge', params);
}

export async function setWindowBackgroundColor(params: types.SetWindowBackgroundColorParams): Promise<void> {
  return invoke('set_window_background_color', params);
}

export async function shareInboxClear(params: types.ShareInboxClearParams): Promise<void> {
  return invoke('share_inbox_clear', params);
}

export async function shareInboxDrain(): Promise<types.ShareBatch[]> {
  return invoke('share_inbox_drain');
}

export async function shareInboxRead(params: types.ShareInboxReadParams): Promise<unknown> {
  return invoke('share_inbox_read', params);
}

export async function showSnapOverlay(): Promise<void> {
  return invoke('show_snap_overlay');
}

export async function startCallForegroundService(): Promise<void> {
  return invoke('start_call_foreground_service');
}

export async function startWindowTrackingWithTarget(params: types.StartWindowTrackingWithTargetParams): Promise<void> {
  return invoke('start_window_tracking_with_target', params);
}

export async function stopCallForegroundService(): Promise<void> {
  return invoke('stop_call_foreground_service');
}

export async function stopWindowTracking(): Promise<void> {
  return invoke('stop_window_tracking');
}

export async function syncDesktopSettings(params: types.SyncDesktopSettingsParams): Promise<types.DesktopRuntimeState> {
  return invoke('sync_desktop_settings', params);
}

export async function uploadWriteChunk(params: types.UploadWriteChunkParams): Promise<void> {
  return invoke('upload_write_chunk', params);
}
